import { StepLabel as MuiStepLabel, StepLabelProps } from "@mui/material";

type Props = StepLabelProps;

export const StepLabel = ({ children, ...props }: Props) => {
  return <MuiStepLabel {...props}>{children}</MuiStepLabel>;
};
